export default "__VITE_ASSET__Zmv83_N7__"